import {defineStore} from "pinia";
import {PenaltyVo} from "@/api/penalty/penaltyType";
import {useMessage, useToast} from "wot-design-uni";
import {DepositOrderVo} from "@/api/deposit/depositType";
import {CreateSku, EditCreateSkuData} from "@/api/sku/skuType";

// 陪玩项目配置
export const usePlayerProjectConfStore = defineStore(
  'PlayerProjectConf',
  () => {

    const editPlayerConfData = ref<CreateSku>()

    return {
      editPlayerConfData,
    }
  })
